// Auto-výběr první varianty na detailu produktu.
// Dokud není zvolená žádná hodnota, Shoptet drží body.disabled-add-to-cart
// a místo dostupnosti, ceny a fotky varianty ukazuje "Zvolte variantu".
// Vybírá se první SKLADOVÁ existující kombinace, ne slepě první radio —
// jinak by první dojem ze stránky mohl být "Vyprodáno".

// Běží jen jednou za načtení stránky. Po AJAX eventech se výběr znovu
// nepřepisuje, aby nekolidoval s ruční volbou zákazníka.
let autoselectDone = false;

// Rozpad klíče kombinace ("24-411-45-3468") na páry "paramId-valueId".
// Porovnává se po párech, ne substringem — "24-41" by jinak matchlo "24-411".
function comboToPairs(combo) {
    const tokens = String(combo).split("-");
    const pairs = [];

    for (let i = 0; i + 1 < tokens.length; i += 2) {
        pairs.push(tokens[i] + "-" + tokens[i + 1]);
    }

    return pairs;
}

// shoptet.variantsSplit.necessaryVariantData → pole { pairs, inStock }.
// (Pozor: availableVariantsResource obsahuje i vyprodané kombinace,
// skladovost se pozná jedině z necessaryVariantData.isNotSoldOut.)
function indexVariantData(variantData) {
    const combos = [];

    if (!variantData || typeof variantData !== "object") {
        return combos;
    }

    Object.keys(variantData).forEach(function (combo) {
        const data = variantData[combo] || {};

        combos.push({
            pairs: comboToPairs(combo),
            inStock: data.isNotSoldOut === true
        });
    });

    return combos;
}

function comboContainsPairs(combo, pairs) {
    return pairs.every(function (pair) {
        return combo.pairs.indexOf(pair) !== -1;
    });
}

// První hodnota parametru (v DOM pořadí), pro kterou existuje kombinace
// navazující na už zvolené páry. requireInStock = jen isNotSoldOut kombinace.
function findValueForParameter(param, selectedPairs, combos, requireInStock) {
    let found = null;

    param.values.some(function (value) {
        const pairs = selectedPairs.concat([param.id + "-" + value]);

        const match = combos.some(function (combo) {
            if (requireInStock && !combo.inStock) {
                return false;
            }
            return comboContainsPairs(combo, pairs);
        });

        if (match) {
            found = value;
        }

        return match;
    });

    return found;
}

// Greedy výběr napříč parametry v DOM pořadí.
// Greedy je bezpečné: hodnota se vybírá jen tehdy, když pro ni existuje
// celý klíč kombinace, takže navazující parametr má vždy aspoň tuto jednu
// kombinaci k dispozici a výběr se nezasekne.
// params = [{ id: "24", values: ["411", "429"] }, …]
function pickFirstAvailableCombination(params, variantData) {
    const combos = indexVariantData(variantData);
    const selected = [];
    const selectedPairs = [];

    (params || []).forEach(function (param) {
        if (!param || !param.values || !param.values.length) {
            return;
        }

        let value = null;

        if (combos.length) {
            value = findValueForParameter(param, selectedPairs, combos, true);

            if (value === null) {
                value = findValueForParameter(param, selectedPairs, combos, false);
            }
        }

        // Data chybí nebo pro parametr neexistuje žádná kombinace → první kandidát
        if (value === null) {
            value = param.values[0];
        }

        selected.push({ id: param.id, value: value });
        selectedPairs.push(param.id + "-" + value);
    });

    return selected;
}

// Kandidátní radia: bez .variant-default (to je Shoptet placeholder "Zvolte variantu")
// a s neprázdnou value.
function radioCandidates($container) {
    return $container.find("input[type='radio']").filter(function () {
        return !$(this).hasClass("variant-default") && $(this).val() !== "" && typeof $(this).val() !== "undefined";
    });
}

function optionCandidates($select) {
    return $select.find("option").filter(function () {
        return $(this).val() !== "" && typeof $(this).val() !== "undefined";
    });
}

// Variantní parametry z DOMu. Příplatky (surcharge) mají také data-parameter-id,
// ale předvybírat je nesmíme — připlácely by se samy.
function readParametersFromDom() {
    const params = [];

    $("[data-parameter-id]").filter(function () {
        const $el = $(this);

        if ($el.hasClass("surcharge-parameter") || $el.closest(".surcharge-list, .surcharges").length) {
            return false;
        }

        // Vnořený data-parameter-id (např. select uvnitř wrapperu) neřešíme dvakrát
        return !$el.parent().closest("[data-parameter-id]").length;
    }).each(function () {
        const $el = $(this);
        const id = $el.attr("data-parameter-id");

        if (!id) {
            return;
        }

        const $select = $el.is("select") ? $el : $el.find("select").first();
        let kind = null;
        let values = [];

        const $radios = radioCandidates($el);

        if ($radios.length) {
            kind = "radio";
            values = $radios.map(function () {
                return String($(this).val());
            }).get();
        } else if ($select.length) {
            kind = "select";
            values = optionCandidates($select).map(function () {
                return String($(this).val());
            }).get();
        }

        // Parametr bez kandidátů se přeskočí
        if (!kind || !values.length) {
            return;
        }

        params.push({
            id: String(id),
            values: values,
            kind: kind,
            element: this,
            select: $select.length ? $select.get(0) : null
        });
    });

    return params;
}

// Shoptet už mohl variantu předvolit (z URL, po reloadu formuláře) — pak nesaháme.
function hasPreselectedParameter(params) {
    return params.some(function (param) {
        const $el = $(param.element);

        if (param.kind === "select") {
            const select = param.select;
            return !!select && select.value !== "";
        }

        return radioCandidates($el).filter(":checked").length > 0;
    });
}

function applySelection(params, selection) {
    selection.forEach(function (choice) {
        const param = params.filter(function (item) {
            return item.id === choice.id;
        })[0];

        if (!param) {
            return;
        }

        if (param.kind === "select") {
            const select = param.select;

            if (!select) {
                return;
            }

            select.value = choice.value;
            select.dispatchEvent(new Event("change", { bubbles: true }));
            return;
        }

        const input = radioCandidates($(param.element)).filter(function () {
            return String($(this).val()) === String(choice.value);
        }).get(0);

        if (!input) {
            return;
        }

        // Nativní click (ne .prop("checked")) — jen ten spustí Shoptet handlery
        // a eventy ShoptetSplitVariantParameterChange / ShoptetVariantAvailable.
        input.click();

        // Pojistka pro případ, že by klik na skrytý input neprošel
        if (!input.checked) {
            const label = $(input).closest("label.advanced-parameter").get(0);

            if (label) {
                label.click();
            }
        }
    });
}

// Vrací true = hotovo (ať už se vybíralo nebo nebylo co dělat),
// false = data variant ještě nejsou k dispozici, zkusit znovu po DOM eventu.
function runAutoselect() {
    if (autoselectDone) {
        return true;
    }

    const dataLayer = window.shopDataLayer || {};
    const productDetail = dataLayer.productDetail || {};

    // undefined = zapnuto, vypíná se jen explicitním false
    if (productDetail.autoSelectFirstVariant === false) {
        autoselectDone = true;
        return true;
    }

    const params = readParametersFromDom();

    if (!params.length || hasPreselectedParameter(params)) {
        autoselectDone = true;
        return true;
    }

    if (!window.shoptet || !window.shoptet.variantsSplit) {
        return false;
    }

    const selection = pickFirstAvailableCombination(params, window.shoptet.variantsSplit.necessaryVariantData);

    applySelection(params, selection);
    autoselectDone = true;

    return true;
}

// Výběrová logika bez DOMu — vystaveno kvůli testovatelnosti a případnému ladění.
window.variantsAutoselect = {
    pickFirstAvailableCombination: pickFirstAvailableCombination,
    comboToPairs: comboToPairs,
    run: runAutoselect
};

$(document).ready(function () {
    if (!$("body").hasClass("type-detail")) {
        return;
    }

    if (runAutoselect()) {
        return;
    }

    // shoptet.variantsSplit ještě nebyl inicializovaný — jeden další pokus
    document.addEventListener("ShoptetDOMContentLoaded", function () {
        runAutoselect();
    }, { once: true });
});
